/* eslint-disable @typescript-eslint/no-explicit-any */

import { homeSecurityPortalApi } from 'data/axios';
import {
  TChangePaymentMethod,
  TChangePaymentMethodRes,
  TCheckoutSessionResponse,
  TCreateCheckoutSessionPayload,
  TPlanList,
  TProductType,
  TSkipReason,
  TSubscriptionBuyType,
  TSubscriptionType,
  TTrialResponse,
  TUpgradPayload
} from 'typings';
import { ApiResponse } from './HttpRequest';
import { endpoints } from './endpoints';

export async function getSubscriptionDetails(): Promise<
  ApiResponse<TSubscriptionType[]>
> {
  const response = await homeSecurityPortalApi.get(endpoints.subscriptionUrl);
  return response;
}

export async function UpgradeUserSubscription(
  payload: TUpgradPayload
): Promise<ApiResponse<TSubscriptionBuyType>> {
  const response = await homeSecurityPortalApi.post(
    endpoints.subscriptionUpgradeUrl,
    payload
  );
  return response;
}

export async function BuyUserSubscription(
  payload: TUpgradPayload
): Promise<ApiResponse<TSubscriptionBuyType>> {
  const response = await homeSecurityPortalApi.post(
    endpoints.subscriptionBuyUrl,
    payload
  );
  return response;
}

export async function changePaymentMethodInSubscription(
  subscriptionId: string,
  payload: TChangePaymentMethod
): Promise<ApiResponse<TChangePaymentMethodRes>> {
  const response = await homeSecurityPortalApi.patch(
    endpoints.changePaymentMethodInSubscription(subscriptionId),
    payload
  );
  return response;
}

export async function checkFreeTrialEligibility(
  productType: TProductType
): Promise<ApiResponse<TTrialResponse>> {
  const response = await homeSecurityPortalApi.get(
    endpoints.checkTrialUrl(productType)
  );
  return response;
}

export async function cancelFreeTrialSubscription(subscriptionId: any) {
  const url = `${endpoints.subscriptionBuyUrl}/${subscriptionId}`;
  const response = await homeSecurityPortalApi.delete(url);
  return response;
}

export const fetchCurrentPlanDetails = async (
  skuId: string
): Promise<ApiResponse<TPlanList>> => {
  const response = await homeSecurityPortalApi.get(
    endpoints.getCurrentPlanDetails(skuId)
  );
  return response;
};

export async function createCheckoutSession(
  payload: TCreateCheckoutSessionPayload
): Promise<ApiResponse<TCheckoutSessionResponse>> {
  const response = await homeSecurityPortalApi.post(
    endpoints.checkoutSession,
    payload
  );
  return response;
}

export async function FetchSkipFreeTrialList() {
  try {
    const response = await homeSecurityPortalApi.get(endpoints.skipFreeTrial);
    return response;
  } catch (error) {
    console.error('Error fetching skip free trial list:', error);
    throw error;
  }
}

export async function SkipFreeTrialAPI(payload: TSkipReason): Promise<any> {
  try {
    const response = await homeSecurityPortalApi.post(
      endpoints.userSkipTrial,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Skip trial error:', error);
    throw error;
  }
}
